import React, { useState, useEffect } from "react";
import { Button, Icon, Dropdown, Popup } from "semantic-ui-react";

interface Tool {
  tool: string;
  type?: string;
}

interface Props {
  activeTool: Tool;
  activateTool: (arg1: Tool) => void;
}

export default function ToolDropdown({ activeTool, activateTool }: Props) {
  // useState
  const [open, setOpen] = useState(false);
  const [tool, setTool] = useState(activeTool);

  // console.warn("ToolDropdown", {activeTool});

  // calls when the tool state is changed
  useEffect(() => {
    activateTool(tool);
  }, [tool]); // eslint-disable-line react-hooks/exhaustive-deps

  const checkDropdownVisibility = () => {
    const $dropdown_menu = document.getElementById("tool_dropdown_menu");
    if ($dropdown_menu.classList.contains("visible")) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  // Return nothing if the renderWidget is set to false
  if (activeTool && activeTool.tool !== "Identify") {
    return (
      <Button
        icon
        secondary
        onClick={() => setTool({ tool: "Identify" })}
        className="no-margin"
      >
        <Icon name="remove" />
      </Button>
    );
  } else {
    return (
      <Popup
        content="Tools"
        position="right center"
        className={`transition fade in`}
        inverted
        size="tiny"
        open={open}
        trigger={
          <Dropdown
            icon="wrench"
            pointing="left"
            className="ui icon button no-margin no-focus"
            onMouseEnter={() => checkDropdownVisibility()}
            onMouseLeave={() => setOpen(false)}
            onClick={() => setOpen(false)}
          >
            <Dropdown.Menu id="tool_dropdown_menu">
              <Dropdown.Header content="Tools" />
              <Dropdown.Divider />
              <Dropdown.Header content="Measurement" />
              <Dropdown.Item
                onClick={() =>
                  setTool({ tool: "Measurement", type: "polyline" })
                }
              >
                <Icon className="esri-icon-minus icon" />
                Line
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() =>
                  setTool({ tool: "Measurement", type: "polygon" })
                }
              >
                <Icon className="esri-icon-polygon icon" />
                Area
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => setTool({ tool: "Measurement", type: "point" })}
              >
                <Icon className="esri-icon-radio-unchecked icon" />
                Point
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => setTool({ tool: "Measurement", type: "parcel" })}
              >
                <Icon className="esri-icon-feature-layer icon" />
                Parcel
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={() => setTool({ tool: "Graphic" })}>
                <Icon className="esri-icon-polygon icon" />
                Graphics
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        }
      />
    );
  }
}
